import app from 'app';
import collectionMain from './collection/collection-main-liquid';

app.add({
  collectionMain,
});
app.mount();
